import { useState, useEffect } from "react";
import {
  Autocomplete,
  DatePicker,
  Grid,
  TextField,
  FormControl,
  Chip,
} from "../../../../components";
import { PessoaService } from "../../../../services";
import { responseErros } from "../../../../utils";

const statusList = [
  { id: "ABERTO", descricao: "ABERTO", status: "ABERTO", cor: "#4FBB53" },
  { id: "IMPORTADO", descricao: "IMPORTADO", status: "IMPORTADO", cor: "#004780" },
];

const FormFiltroAvancado = ({
  valueInput,
  onChangeInput,
  valueDate,
  onChangeDate,
  valueAutocomplete,
  onChangeAutocomplete,
  onChangeMultipleStatus,
}) => {
  const pessoaService = new PessoaService();
  const [clienteList, setClienteList] = useState([]);

  useEffect(() => {
    buscarClientes();
  }, []);

  const buscarClientes = () => {
    pessoaService
      .getAll({ nonPaginated: true, tiposPessoaId: 1 })
      .then((result) => {
        if (!result.isAxiosError) {
          setClienteList(result.data);
        } else {
          responseErros(result);
        }
      });
  };

  const statusSelecionados = statusList.filter((s) =>
    valueInput("status")?.includes(s.id),
  );

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <TextField
          id="numeroDocumento"
          name="numeroDocumento"
          label="Nº Documento"
          variant="outlined"
          margin="normal"
          fullWidth
          onChange={(event) => onChangeInput(event)}
          value={valueInput("numeroDocumento")}
        />
      </Grid>
      <Grid item xs={12}>
        <FormControl variant="outlined" margin="normal" fullWidth>
          <Autocomplete
            id="clienteId"
            name="clienteId"
            options={clienteList}
            noOptionsText="Sem opções"
            autoHighlight
            getOptionLabel={(option) => option?.nomeRazaoSocial ?? ""}
            getOptionSelected={(option, value) =>
              option?.nomeRazaoSocial === value?.nomeRazaoSocial
            }
            renderInput={(params) => (
              <TextField {...params} label="Cliente" variant="outlined" />
            )}
            onChange={(e, value) => onChangeAutocomplete("clienteId", value)}
            value={valueAutocomplete(clienteList, "clienteId")}
          />
        </FormControl>
      </Grid>
      <Grid item xs={6}>
        <DatePicker
          id="dataCreatedAtStart"
          name="dataCreatedAtStart"
          label="Data Lançamento De"
          format="dd/MM/yyyy"
          value={valueDate("dataCreatedAtStart")}
          onChange={(date) => onChangeDate("dataCreatedAtStart", date)}
        />
      </Grid>
      <Grid item xs={6}>
        <DatePicker
          id="dataCreatedAtEnd"
          name="dataCreatedAtEnd"
          label="Data Lançamento Até"
          format="dd/MM/yyyy"
          value={valueDate("dataCreatedAtEnd")}
          onChange={(date) => onChangeDate("dataCreatedAtEnd", date)}
        />
      </Grid>
      <Grid item xs={6}>
        <DatePicker
          id="dataVencimentoStart"
          name="dataVencimentoStart"
          label="Data Vencimento De"
          format="dd/MM/yyyy"
          value={valueDate("dataVencimentoStart")}
          onChange={(date) => onChangeDate("dataVencimentoStart", date)}
        />
      </Grid>
      <Grid item xs={6}>
        <DatePicker
          id="dataVencimentoEnd"
          name="dataVencimentoEnd"
          label="Data Vencimento Até"
          format="dd/MM/yyyy"
          value={valueDate("dataVencimentoEnd")}
          onChange={(date) => onChangeDate("dataVencimentoEnd", date)}
        />
      </Grid>
      <Grid item xs={12}>
        <Autocomplete
          multiple
          id="status"
          name="status"
          options={statusList}
          noOptionsText="Sem opções"
          autoHighlight
          filterSelectedOptions
          getOptionLabel={(option) => option?.status || ""}
          onChange={(_, newValue) => onChangeMultipleStatus(newValue)}
          value={statusSelecionados}
          renderInput={(params) => (
            <TextField
              {...params}
              variant="outlined"
              label="Status"
              margin="normal"
              fullWidth
            />
          )}
          renderOption={(props, option) => (
            <li {...props}>
              {option.status}
              <i
                className="ph-fill ph-circle"
                style={{ color: option.cor, marginLeft: 8 }}
              ></i>
            </li>
          )}
          renderTags={(value, getTagProps) =>
            value.map((option, index) => (
              <Chip
                {...getTagProps({ index })}
                key={index}
                label={
                  <div style={{ display: "flex", alignItems: "center" }}>
                    {option.status}
                    <i
                      className="ph-fill ph-circle"
                      style={{ color: option.cor, marginLeft: 6 }}
                    ></i>
                  </div>
                }
              />
            ))
          }
        />
      </Grid>
    </Grid>
  );
};

export default FormFiltroAvancado;
